import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'primereact/resources/themes/md-light-indigo/theme.css';
import 'primeflex/primeflex.css'
import App from './App';
import {ProfileContextProvider} from "./context/profile.context";
import {ErrorContextProvider} from "./context/error.context";
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <ErrorContextProvider>
            <ProfileContextProvider>
                    <App/>
            </ProfileContextProvider>
        </ErrorContextProvider>
    </BrowserRouter>
);
